module.exports = __webpack_public_path__ + "cbbb782c055d3e71e009fbe71b453a3a.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/de.json
// module id = 1144
// module chunks = 0